 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		7: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "sports2-static/chunk." + ({"0":"source~/esports-betting-rules-TR~bet-builder-rules-DE~bet-builder-rules-EN~bet-builder-rules-ES~bet-~078fb09e","1":"source~/esports-betting-rules-TR~bet-builder-rules-DE~bet-builder-rules-EN~bet-builder-rules-ES~bet-~e20a97ce","2":"source~/esports-betting-rules-TR~esports-betting-rules-DA~esports-betting-rules-DE~esports-betting-r~11b5dbfd","5":"source~virtual-esports-betting-rules-EN~virtual-esports-betting-rules-IT~virtual-esports-betting-rul~c400071f","8":"source~i18n-widgets-en-json","9":"source~i18n-widgets-en-uk-json","13":"source~/esports-betting-rules-TR","14":"source~bet-builder-rules-DE","15":"source~bet-builder-rules-EN","16":"source~bet-builder-rules-ES","17":"source~bet-builder-rules-ES-MX","18":"source~bet-builder-rules-ET","19":"source~bet-builder-rules-FI","20":"source~bet-builder-rules-FR","21":"source~bet-builder-rules-IT","22":"source~bet-builder-rules-JA","23":"source~bet-builder-rules-KA","24":"source~bet-builder-rules-LT","25":"source~bet-builder-rules-LV","26":"source~bet-builder-rules-PL","27":"source~bet-builder-rules-PT-BR","28":"source~bet-builder-rules-RO","29":"source~bet-builder-rules-RU","30":"source~bet-builder-rules-SQ","31":"source~bet-builder-rules-TR","32":"source~bet-details-page","33":"source~betting-history-container","34":"source~betting-history-page","35":"source~betting-rules-DA","36":"source~betting-rules-DE","37":"source~betting-rules-EN","38":"source~betting-rules-ES","39":"source~betting-rules-ES-MX","40":"source~betting-rules-FR","41":"source~betting-rules-IT","42":"source~betting-rules-JA","43":"source~betting-rules-PL","44":"source~betting-rules-PT","45":"source~betting-rules-PT-BR","46":"source~betting-rules-RO","47":"source~betting-rules-RU","48":"source~betting-rules-SQ","49":"source~betting-rules-TR","50":"source~bonus-info","51":"source~cashout-terms-AR","52":"source~cashout-terms-DA","53":"source~cashout-terms-DE","54":"source~cashout-terms-EN","55":"source~cashout-terms-ES","56":"source~cashout-terms-ES-MX","57":"source~cashout-terms-ET","58":"source~cashout-terms-FI","59":"source~cashout-terms-FR","60":"source~cashout-terms-IT","61":"source~cashout-terms-JA","62":"source~cashout-terms-KA","63":"source~cashout-terms-KU","64":"source~cashout-terms-LT","65":"source~cashout-terms-LV","66":"source~cashout-terms-PL","67":"source~cashout-terms-PT","68":"source~cashout-terms-PT-BR","69":"source~cashout-terms-RO","70":"source~cashout-terms-RU","71":"source~cashout-terms-SQ","72":"source~cashout-terms-SR","73":"source~cashout-terms-TR","74":"source~esports-betting-rules-DA","75":"source~esports-betting-rules-DE","76":"source~esports-betting-rules-EN","77":"source~esports-betting-rules-ES","78":"source~esports-betting-rules-ES-MX","79":"source~esports-betting-rules-ET","80":"source~esports-betting-rules-FI","81":"source~esports-betting-rules-FR","82":"source~esports-betting-rules-IT","83":"source~esports-betting-rules-JA","84":"source~esports-betting-rules-KA","85":"source~esports-betting-rules-LT","86":"source~esports-betting-rules-LV","87":"source~esports-betting-rules-PL","88":"source~esports-betting-rules-PT","89":"source~esports-betting-rules-PT-BR","90":"source~esports-betting-rules-RO","91":"source~esports-betting-rules-RU","92":"source~esports-betting-rules-SQ","93":"source~esports-betting-rules-SR","96":"source~generated-mappings","97":"source~i18n-en-json","98":"source~i18n-en-uk-json","100":"source~settings-page","101":"source~streaming-carousel","102":"source~virtual-esports-betting-rules-EN","103":"source~virtual-esports-betting-rules-IT","104":"source~virtual-esports-betting-rules-JA","105":"source~virtual-esports-betting-rules-PL","107":"vendors~rc-slider","108":"vendors~react-google-recaptcha","109":"vendors~streaming-carousel"}[chunkId]||chunkId) + "." + {"0":"75bc98f470c5564c2cd8","1":"7eb845b29c2a1388b0ff","2":"e23401d74b0757823ee0","3":"603ace0fd36a742a491f","4":"12dcca2e8715f6f34fe1","5":"5c8d55315ef6dc8e8325","6":"40f67efeaeb09c6a92c3","8":"018b246ecd851ba34264","9":"df8cf9419d27ad85ec7f","13":"d2dab7840c846c14ffb7","14":"4118d84471756933b6a4","15":"670ed8059867a3297589","16":"cfca5a1a8021ef65539b","17":"8099a678fc78d6b31c24","18":"59e98d1d107c7524332d","19":"650d224b1537acad3828","20":"21189326faf4eca7d1c0","21":"8defd31ce88b353bae57","22":"84bb5f805b9218802466","23":"a4c96f4f30190b43251d","24":"eebd8ce3215e226821a9","25":"2365aaed09dc46527a42","26":"3503169444979424edcd","27":"096c6e17d2d580e6277b","28":"8587a3cc609d44b2e23a","29":"a7c7c478bf740c0fb773","30":"3a4ca71863a4dd262c9b","31":"fb4934baafff96b4c047","32":"e2b231f30abb9a41f6d1","33":"c4448b5bb01c1e5c28e4","34":"22cece3db635d39d225d","35":"bf534a7c4317ad47f2c8","36":"4f6deb3284b9bb44410c","37":"2c6d91193efade8b66da","38":"e245004ad489d69b5d33","39":"538052f0944131d5871e","40":"c949d2ad95c354799309","41":"a32b13c07a8e6465d785","42":"2a091be7250d7ae7c928","43":"023a84fe51a2146496df","44":"248202d08b701886f229","45":"1717980e53b5c40b9739","46":"e1b90e36d2a2d85652bc","47":"e7ca2c6b486b76d7f4ea","48":"0e8231f7abdb65dc83ab","49":"f1e24cdecd9ff943ffc7","50":"3c05b4495fa4bbf55b57","51":"cf1ef8401a0f7c9aa283","52":"646f8a27606137d2f1f2","53":"8a66a73a4961e73e23ba","54":"0f19eb862bccce82417c","55":"81135e4575a1acc4b2c2","56":"5c30cde3cf832d4c20e5","57":"c6dccf95fe883c2da9e1","58":"709ad4047143b67ad4cf","59":"5cae71ae1f56f565876f","60":"b5bad67fdeb8b0805eb8","61":"ad63b0b0458fab0e1c51","62":"f73aeb4a9124508ee5fc","63":"c5d00bec74a93d000651","64":"22c147d7314623717b17","65":"14cba78ff6537f2eb497","66":"e55cc2041509ff29d32d","67":"c84d76d984c52cdfe517","68":"c7123e5b9f0a2fe899fb","69":"a5dbafbdb1531df063dc","70":"44f881c54a4301a38a59","71":"5efee31d91b8bf4cc31a","72":"0c488ea8fe3f2ae1bb05","73":"d74ae16d7090a47cf08c","74":"9c7e0982f0f2b060a43a","75":"09d628d1ddd3be47ff0d","76":"a94f71d9957692d67b47","77":"1def022b6ea09cca6332","78":"a62e791e897f10c5f219","79":"51696c997fc7ebc94885","80":"5608784e4f5b75ee09cb","81":"eb18ed1b3185ee2bfeba","82":"024d7138465167a384a6","83":"974b2e6a853e3d5b21ae","84":"7b90a2e1d64856e62b85","85":"cac9d34ffeddd3e86d53","86":"4749bf18320ae8a86430","87":"7f0edb7d713c432f45af","88":"0040b257e32209b2a7b3","89":"78d9e6053a981f3ab833","90":"50ba3eb18457a8f5c4c3","91":"630024c2b9e4dc2179dc","92":"a21a2edace64a71608b9","93":"5cb4d8befefb1271801b","96":"5a15acd13c32e91bfe56","97":"0644622136c9dde8107d","98":"3eadd422885099fbf716","100":"821b1294ec4c0696f92e","101":"e0000733fd5b4c2223fa","102":"7eea922daec413da4ded","103":"ae00110c766a72902086","104":"c9573955097125fff813","105":"aba19905818dcafe44f8","107":"d6bbf52be04bbe137c1d","108":"a59f101841a118890600","109":"b09bcd5265449183330f","110":"fc8e086bf57b56023efc","111":"e281e92b752e915fd9d5","112":"6080669497dae66aef2b","113":"0d2bc95194811cc74399","114":"4a485473fa663bcae6f9","115":"988b5c7daf4f67db92ca","116":"8cee833788c371d0f539","117":"b995b3a7a81ce75a3442","118":"8ef03471e8cc67667dac","119":"b54c2f756eab5e66b40e","120":"eb1768795f49aa048aed","121":"9a9f15dcd1beb8981f85","122":"1dd8101fe305df8dcd68","123":"d96d27ac2a4178610727","124":"54a94129b13b15e6f019","125":"3ffb452687bd37501266","126":"4d3b2d03eb0c3dc12cd4","127":"8c18da85fd7188957db0","128":"49743dcfc18ed31215fd","129":"32d24ef7892fc1fc4383","130":"0eac23376444aaa57a6b"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonpOMFE2_App"] = window["webpackJsonpOMFE2_App"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
